<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de años</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear año</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save">
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-1" description="Ejemplo: 2024">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre del año" trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Descripción:" label-for="input-2" description="Ejemplo: Año 2024">
                <b-form-input id="input-2" v-model="form.description" placeholder="Ingrese la descripción del año"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Matrículas:" label-for="input-2">
                <b-form-checkbox id="checkbox-1" v-model="form.isNext" name="checkbox-1">
                  Habilitado para matrículas
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de años</strong>
            </h5>
            <empty-table v-show="yearList.length === 0"/>
            <b-table striped hover :fields="columns" :items="yearList" head-variant="light" v-show="yearList.length > 0" responsive>
              <template #cell(current)="year">
                <b-badge :variant="year.item.current ? 'success' : 'secondary'">
                  {{ year.item.current ? 'Si' : 'No' }}
                </b-badge>
              </template>
              <template #cell(isNext)="year">
                <b-badge :variant="year.item.isNext ? 'success' : 'secondary'">
                  {{ year.item.isNext ? 'Si' : 'No' }}
                </b-badge>
              </template>
              <template #cell(actions)="year">
                <b-link class="btn btn-light mr-2" @click="showModalEditYear(year.item)">
                  <i class="fa fa-pencil text-blue" /> Editar
                </b-link> |
                <b-link class="btn btn-light mr-2" @click="alertDeleteYear(year.item)"><i class="fa fa-trash-o text-red" /> Eliminar</b-link>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-year" ref="modal" title="Editar año"  hide-footer>
      <b-form @submit="edit" ref="todoform">
        <div class="row mb-3">
          <div class="col">
            <b-link v-if="visibleStructure" class="btn btn-light btn-block mr-2" @click="showModalBringPastYears()">
              <i class="fa fa-recycle text-blue" /> Usar estructura de años anteriores
            </b-link>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-md-6">
            <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-1" description="Ejemplos: 2024">
              <b-form-input id="input-1-edit" v-model="yearToEdit.name" required placeholder="Ingrese el nombre del año" trim></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-2-edit" label="Descripción:" label-for="input-2" description="Ejemplo: Año 2024">
              <b-form-input id="input-2-edit" v-model="yearToEdit.description" placeholder="Ingrese la descripción del año"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-3-edit" label="Activar año:" label-for="input-3">
              <a-switch v-model="yearToEdit.current" />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-4-edit" label="Próximo año:" label-for="input-4">
              <a-switch v-model="yearToEdit.isNext" />
            </b-form-group>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col col-lg-5">
            <b-button type="submit" variant="primary" class="mb-3 mt-3">Guardar</b-button>
            <b-button @click="$bvModal.hide('edit-year')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
    <b-modal size="md" id="bring-years" ref="modal" title="Estructuras pasadas" hide-footer @onHidden="onHidden()">
      <b-form ref="new">
        <b-row align-v="center">
          <b-col md="8">
            <b-form-group id="input-group-2" label="Año a usar como base:" label-for="input-year" description="Trae la estructura completa del año seleccionado">
              <b-form-select v-model="yearSelected" :options="yearOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col v-if="yearSelected !== null">
            <b-button @click="bringYears()" variant="primary" class="mr-2 mb-3 mt-3">Aplicar</b-button>
          </b-col>
        </b-row>
        <template v-if="yearSelected !== null">
          <b-row v-for="(value, name, index) in yearDataToBring" :key="index" >
            <b-col :id="index" sm="4" lg="6">{{ yearDataToBring[name].text }}</b-col>
            <b-col :id="index" sm="1" lg="1"><b-form-checkbox v-model="yearDataToBring[name].value" name="check-button" switch :disabled="yearDataToBring[name].state !== null" /></b-col>
            <b-col align-self="center" v-if="yearDataToBring[name].state !== null" :id="index" sm="1" lg="1">
              <b-spinner v-if="yearDataToBring[name].state === 'loading'" type="grow" label="Spinning"></b-spinner>
              <i class="fa fa-times-circle-o text-red" v-if="!yearDataToBring[name].state" />
              <i class="fa fa-check-circle-o text-green" v-if="yearDataToBring[name].state === true" />
            </b-col>
          </b-row>
        </template>
        <b-row align-v="center" class="m-auto pl-5 pb-2" v-for="(value, key) in statusInfo" v-bind:key="key.id" v-show="visibleStatus">
          <b>{{ value }} </b>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import emptyTable from '@/components/custom/cardEmptyList'
import apiClient2 from '@/services/axios/v2.js'
import Swal from 'sweetalert2'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'ManagementYear',
  components: {
    emptyTable,
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        current: false,
        isNext: false,
      },
      columns: [
        { key: 'name', label: 'Nombres' },
        { key: 'description', label: 'Descripción' },
        { key: 'current', label: 'Actual' },
        { key: 'isNext', label: 'Próximo' },
        { key: 'actions', label: 'Acciones' },
      ],
      yearToEdit: {
        id: '',
        name: '',
        description: '',
        current: false,
        isNext: false,
      },
      yearList: [],
      yearOptions: [
        { value: null, text: 'Seleccione un año' },
      ],
      yearSelected: null,
      yearDataToBring: {
        educationLevel: { text: 'Niveles de educación', value: false, state: null },
        qualificationRange: { text: 'Rangos de calificación', value: false, state: null },
        grade: { text: 'Grados', value: false, state: null },
        group: { text: 'Grupos', value: false, state: null },
        area: { text: 'Areas', value: false, state: null },
        subject: { text: 'Asignaturas', value: false, state: null },
        elective: { text: 'Electivas', value: false, state: null },
        period: { text: 'Periodos', value: false, state: null },
      },
      statusInfo: {},
      visibleStatus: false,
      visibleStructure: false,
    }
  },
  beforeRouteEnter (to, from, next) {
    apiClient2.get('/years').then(response => {
      next(vm => vm.setData('', response.data))
    }).catch(err => {
      next(vm => vm.setData(err, [])) // TODO Mostrar error
    })
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.yearList = data.data
        if (this.yearList.length > 1) {
          this.visibleStructure = true
        }
      }
    },
    onHidden() {
      this.yearToEdit = {
        id: '',
        name: '',
        description: '',
        current: false,
        isNext: false,
      }
      this.yearSelected = null
      const keys = Object.keys(this.yearDataToBring)
      for (const key of keys) {
        this.yearDataToBring[key].value = false
        this.yearDataToBring[key].state = null
      }
    },
    search() {
      apiClient2.get('/years').then(response => {
        this.yearList = response.data.data
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    save(evt) { // Guarda un grado llamando a la API
      evt.preventDefault()
      const newYear = { ...this.form }
      apiClient2.post('/years', newYear).then((response) => {
        console.log(response)
        Toast.fire({
          icon: 'success',
          title: 'El año fue creado con éxito.',
        })
        this.cleanForms()
        this.search()
      }).catch(err => {
        this.$notification.error({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    showModalEditYear(year) { // Abre el modal para editar el grado
      this.yearToEdit = Object.assign({}, year)
      this.$bvModal.show('edit-year')
    },
    alertDeleteYear(year) {
      Swal.fire({
        title: 'Confirmar eliminación',
        html: `¿Está seguro de que desea eliminar el año ${year.name}? <b>Descripción:</b> Se eliminará toda la información relacionada a este año.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient2.delete(`/years/${year.id}`).then((response) => {
            Toast.fire({
              icon: 'success',
              title: 'Post eliminado correctamente',
            })
            this.search()
          }).catch(error => {
            Toast.fire({
              icon: 'warning',
              title: 'Ooops ocurrió un error' + showErrorMessage(error),
            })
          })
        }
      })
    },
    showModalBringPastYears() {
      this.$bvModal.hide('edit-year')
      this.yearOptions = this.yearList
        .filter(year => !year.current && !year.isNext)
        .map(year => {
          return {
            value: year.id,
            text: year.name,
          }
        })
      this.yearOptions.unshift({ value: null, text: 'Seleccione un año' })
      this.$bvModal.show('bring-years')
    },
    edit(evt) { // Edita un grado llamando a la API
      evt.preventDefault()
      // TODO Validar datos
      const gotDate = new Date(this.yearToEdit.finalDate)
      this.yearToEdit.finalDate = gotDate
      apiClient2.put(`/years/${this.yearToEdit.id}`, this.yearToEdit).then(response => {
        this.search()
        this.cleanForms()
        console.log(response)
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            'Año actualizado correctamente.',
        })
        this.$bvModal.hide('edit-year')
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    cleanForms() {
      this.form = {
        name: '',
        description: '',
        current: false,
        isNext: false,
      }
    },
    async bringYears() {
      const yearSelected = this.yearSelected
      if (yearSelected === null) {
        Toast.fire({
          icon: 'warning',
          title: 'Por favor seleccione una opción valida.',
        })
        return
      }
      const keys = Object.keys(this.yearDataToBring)
      let keysToUse = 0
      let keysUsed = 0
      for (const key of keys) {
        if (this.yearDataToBring[key].value) {
          keysToUse += 1
          this.yearDataToBring[key].state = 'loading'
          await apiClient2.post('/years/structure/', { idYearToStructure: this.yearToEdit.id, idYearSelected: yearSelected, key: key }).then(response => {
            keysUsed += 1
            this.yearDataToBring[key].state = true
          }).catch(e => {
            this.yearDataToBring[key].state = false
          })
        }
      }
      Toast.fire({
        icon: (keysToUse === keysUsed) ? 'success' : 'warning',
        title: (keysToUse === keysUsed) ? 'Estructuras generadas satisfactoriamente.' : 'Ocurrieron errores durante el proceso.',
      })
    },
  },
}
</script>
